import {
  Icon,
  Tooltip,
  TooltipTrigger,
  WithNAFallback,
} from '@toggle/design-system';
import { formatPercentage, getPriceStatus } from '@toggle/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { priceChangeColors } from '~/utils/common/utils';

import styles from './PercentageCell.module.scss';

export interface PercentageCellProps {
  value?: number;
  suffix?: '%' | 'bps';
  showStarIcon?: boolean;
}

export const PercentageCell = ({
  value,
  suffix = '%',
  showStarIcon,
}: PercentageCellProps) => {
  const { t } = useTranslation('scenario');
  const status = getPriceStatus(value);

  return (
    <div className={styles.root}>
      {showStarIcon && (
        <Tooltip
          label={
            <span className={styles.nonNumericText}>
              {t('scenario:table.tooltips.starIcon')}
            </span>
          }
          trigger={TooltipTrigger.Hover}
        >
          <span>
            <Icon
              iconName="StarFill"
              fillColor="var(--icon-primary)"
              size={12}
            />
          </span>
        </Tooltip>
      )}

      <span
        className={styles.coloredValue}
        style={{ color: priceChangeColors[status] }}
      >
        <WithNAFallback
          value={
            typeof value === 'number' &&
            formatPercentage(value, { suffix, addPlus: suffix === '%' })
          }
        />
      </span>
    </div>
  );
};
